/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { useState } from 'react';
import dayjs from 'dayjs'
import PatientDropdownAlertWithSearch from './dropdownWithSearchForPatient';
import DropdownWithSearchUser from './dropdownWithSearchUser';
import DropdownWithSearchOrganization from './dropdownWithSearchOrganization';
import DropdownWithSearchProvider from './dropdownWithSearchProvider';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import {handleEmptyUsersDropdown, handleFillFromSearchParamsUsers, resetOrgList as resetOrgUserList, resetTempFilterUsersOpen } from '../../../../../../../redux/wellnessFilterUserSlice';
import {handleEmptyDropdown, handleFillFromSearchParamsPatients, resetOrgList, resetTempFilterOpen } from '../../../../../../../redux/wellnessFilterSlice';
import {handleEmptyOrgDropdown, handleFillFromSearchParamsOrg, resetOrgList as resetOrganizationList, resetTempFilterOrgOpen } from '../../../../../../../redux/wellnessFilterOrganizationSlice';
import { handleEmptyProviderDropdown, handleFillFromSearchParamsProviders, resetOrgList as resetProviderList, resetTempFilterProviderOpen } from '../../../../../../../redux/wellnessFilterProviderSlice';




export default function FilterBtn({dateError,setdateError,isFilterOpen,setIsFilterOpen,isFilterOrganization,initialState,filterValues,setFilterValues,handleOpenFilter,selectedOrganizationName,setSelectedOrganizationName,setSubDivisionDataLoading,subDivisionDataLoading,userArr,isPatientSearch}) {

    const totalUsers = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.totalUsers)
    const totalPatients = useSelector(state=>state.filterSelect.selectedUsers.totalUsers)

    const totalOrganization = useSelector(state=>state.filterOrgNameSelect?.selectedFilterOrg.totalUsers)
    const totalProvider = useSelector(state=>state.filterProviderNameSelect?.selectedFilterProvider.totalUsers)

    const [searchParams,setSearchParams] = useSearchParams()
    const selectedPatients = useSelector(state=>state.filterSelect.selectedUsers.selectedArr)
    const unselectedPatients = useSelector(state=>state.filterSelect.selectedUsers.unselectedArr)
    const isCheckedPatients = useSelector(state=>state.filterSelect.selectedUsers.isCheckedAll)

    const selectedUserNames = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.selectedArr)
    const unselectedUserNames = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.unselectedArr)
    const isCheckedUsers = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.isCheckedUsersAll)

    const selectedOrgNames = useSelector(state=>state.filterOrgNameSelect?.selectedFilterOrg.selectedArr)
    const unselectedOrgNames = useSelector(state=>state.filterOrgNameSelect?.selectedFilterOrg.unselectedArr)
    const isCheckedOrg = useSelector(state=>state.filterOrgNameSelect?.selectedFilterOrg.isCheckedUsersAll)

    const selectedProviderNames = useSelector(state=>state.filterProviderNameSelect.selectedFilterProvider.selectedArr)
    const unselectedProviderNames = useSelector(state=>state.filterProviderNameSelect.selectedFilterProvider.unselectedArr)
    const isCheckedProvider = useSelector(state=>state.filterProviderNameSelect.selectedFilterProvider.isCheckedUsersAll)

    const [isSelectAllChecked,setIsSelectAllChecked] = useState(searchParams.get('selected_patient_ids')?false:true)
    const [isSearchedSelectAllChecked,setIsSearchedSelectAllChecked] = useState(true)

    const [isSelectAllUsersChecked,setisSelectAllUsersChecked] = useState(searchParams.get('selected_user_ids')?false:true)
    const [isSearchedSelectAllUsersChecked,setisSearchedSelectAllUsersChecked] = useState(true)

    const [isSelectAllOrgChecked,setisSelectAllOrgChecked] = useState(searchParams.get('selected_organization_ids')?false:true)
    const [isSearchedSelectAllOrgChecked,setisSearchedSelectAllOrgChecked] = useState(true)

    const [isSelectAllProviderChecked,setisSelectAllProviderChecked] = useState(searchParams.get('selected_provider_ids')?false:true)
    const [isSearchedSelectAllProviderChecked,setisSearchedSelectAllProviderChecked] = useState(true)

    const [suggestions,setSuggestions] = useState('')
    const dispatch = useDispatch()
    const [usersuggestions,setusersuggestions] = useState('')

    const [orgsuggestions,setorgsuggestions] = useState('')

    const [providersuggestions,setprovidersuggestions] = useState('')
  
  
    
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        
        if (type) {
            // params.filter = "true";
            // Dispatch the filter values to Redux
            if((!isSelectAllChecked&&selectedPatients?.length===0&&unselectedPatients?.length===0)||
            (!isSelectAllUsersChecked&&selectedUserNames?.length===0&&unselectedUserNames?.length===0) || 
            (!isSelectAllOrgChecked&&selectedOrgNames?.length===0&&unselectedOrgNames?.length===0) || 
            (!isSelectAllProviderChecked&&selectedProviderNames?.length===0&&unselectedProviderNames?.length===0)){

                params.unselected_patient_ids!==null&&delete params.unselected_patient_ids
                params.selected_patient_ids!==null&&delete params.selected_patient_ids
                params.unselected_user_ids!==null&&delete params.unselected_user_ids
                params.selected_user_ids!==null&&delete params.selected_user_ids
                params.unselected_organization_ids!==null&&delete params.unselected_organization_ids
                params.selected_organization_ids!==null&&delete params.selected_organization_ids
                params.unselected_provider_ids!==null&&delete params.unselected_provider_ids
                params.selected_provider_ids!==null&&delete params.selected_provider_ids
                !isSelectAllChecked&&selectedPatients?.length===0?params.selected_patient_ids="empty":''
                !isSelectAllUsersChecked&&selectedUserNames?.length===0?params.selected_user_ids="empty":''
                !isSelectAllOrgChecked&&selectedOrgNames?.length===0?params.selected_organization_ids="empty":''
                !isSelectAllProviderChecked&&selectedProviderNames?.length===0?params.selected_provider_ids="empty":''

            }else if((isSelectAllChecked&&selectedPatients?.length===0&&unselectedPatients?.length===0)||
            (isSelectAllUsersChecked&&selectedUserNames?.length===0&&unselectedUserNames?.length===0) || 
            (isSelectAllOrgChecked&&selectedOrgNames?.length===0&&unselectedOrgNames?.length===0) ||
            (isSelectAllProviderChecked&&selectedProviderNames?.length===0&&unselectedProviderNames?.length===0) 
            ){
                params.selected_patient_ids!==null&&delete params.selected_patient_ids
                params.selected_user_ids!==null&& delete params.selected_user_ids
                params.selected_organization_ids!==null&& delete params.selected_organization_ids
                params.selected_provider_ids!==null&& delete params.selected_provider_ids
            }

            params.page_number=1
            if(isSelectAllChecked&&unselectedPatients?.length===0){
                if(searchParams.get('unselected_patient_ids')!==null){
                    delete params.unselected_patient_ids
                }
            }
            if(!isSelectAllChecked&&selectedPatients?.length===0){
                if(searchParams.get('selected_patient_ids')!==null && searchParams.get('selected_patient_ids')!=='empty'){
                    delete params.selected_patient_ids
                }
            }
            if(!isSelectAllChecked&&unselectedPatients?.length!==0){
                if(searchParams.get('selected_patient_ids')!==null){
                    params.selected_patient_ids='empty'
                }
            }
           
            if(isSelectAllChecked&&unselectedPatients?.length!==0){
                if(searchParams.get('selected_patient_ids')!==null){
                    delete params.selected_patient_ids
                }
                unselectedPatients?.length===totalPatients?params['selected_patient_ids']='empty':params['unselected_patient_ids']=unselectedPatients.join(',')
            }else if(!isSelectAllChecked&&selectedPatients?.length!==0){
                if(searchParams.get('unselected_patient_ids')!==null){
                    delete params.unselected_patient_ids
                }
                params['selected_patient_ids']=selectedPatients.join(',')
            }

            // monitor user filter select
            if(isSelectAllUsersChecked&&unselectedUserNames?.length===0){
                if(searchParams.get('unselected_user_ids')!==null){
                    delete params.unselected_user_ids
                }
            }
            if(!isSelectAllUsersChecked&&selectedUserNames?.length===0){
                if(searchParams.get('selected_user_ids')!==null && searchParams.get('selected_user_ids')!=='empty'){
                    delete params.selected_user_ids
                }
            }
            if(!isSelectAllUsersChecked&&unselectedUserNames?.length!==0){
                if(searchParams.get('selected_user_ids')!==null){
                    params.selected_user_ids='empty'
                }
            }
            
            if(isSelectAllUsersChecked&&unselectedUserNames?.length!==0){
                if(searchParams.get('selected_user_ids')!==null){
                    delete params.selected_user_ids
                }
                unselectedUserNames?.length===totalUsers?params['selected_user_ids']='empty':params['unselected_user_ids']=unselectedUserNames.join(',')
            }else if(!isSelectAllUsersChecked&&selectedUserNames?.length!==0){
                if(searchParams.get('unselected_user_ids')!==null){
                    delete params.unselected_user_ids
                }
                params['selected_user_ids']=selectedUserNames.join(',')
            }
            
            // org setfilter
            if(isSelectAllOrgChecked&&unselectedOrgNames?.length===0){
                if(searchParams.get('unselected_organization_ids')!==null){
                    delete params.unselected_organization_ids
                }
            }
            if(!isSelectAllOrgChecked&&selectedOrgNames?.length===0){
                if(searchParams.get('selected_organization_ids')!==null && searchParams.get('selected_organization_ids')!=='empty'){
                    delete params.selected_organization_ids
                }
            }
            if(!isSelectAllOrgChecked&&unselectedOrgNames?.length!==0){
                if(searchParams.get('selected_organization_ids')!==null){
                    params.selected_organization_ids='empty'
                }
            }
            
            if(isSelectAllOrgChecked&&unselectedOrgNames?.length!==0){
                if(searchParams.get('selected_organization_ids')!==null){
                    delete params.selected_organization_ids
                }
                unselectedOrgNames?.length===totalOrganization?params['selected_organization_ids']='empty':params['unselected_organization_ids']=unselectedOrgNames.join(',')
            }else if(!isSelectAllOrgChecked&&selectedOrgNames?.length!==0){
                if(searchParams.get('unselected_organization_ids')!==null){
                    delete params.unselected_organization_ids
                }
                params['selected_organization_ids']=selectedOrgNames.join(',')
            }

            // provider user filter select
            if(isSelectAllProviderChecked&&unselectedProviderNames?.length===0){
                if(searchParams.get('unselected_provider_ids')!==null){
                    delete params.unselected_provider_ids
                }
            }
            if(!isSelectAllProviderChecked&&selectedProviderNames?.length===0){
                if(searchParams.get('selected_provider_ids')!==null && searchParams.get('selected_provider_ids')!=='empty'){
                    delete params.selected_provider_ids
                }
            }
            if(!isSelectAllProviderChecked&&unselectedProviderNames?.length!==0){
                if(searchParams.get('selected_provider_ids')!==null){
                    params.selected_provider_ids='empty'
                }
            }
          
            if(isSelectAllProviderChecked&&unselectedProviderNames?.length!==0){
                if(searchParams.get('selected_provider_ids')!==null){
                    delete params.selected_provider_ids
                }
                let ParamsunselectedProviderNames=unselectedProviderNames?.map(item=>item==='blankREC'?"''":item)
                unselectedProviderNames?.length===totalProvider?params['selected_provider_ids']='empty':params['unselected_provider_ids']=(ParamsunselectedProviderNames.join(','))

            }else if(!isSelectAllProviderChecked&&selectedProviderNames?.length!==0){
                if(searchParams.get('unselected_provider_ids')!==null){
                    delete params.unselected_provider_ids
                }
                let ParamsselectedProviderNames=selectedProviderNames.map(item=>item==='blankREC'?"''":item)
                params['selected_provider_ids']=(ParamsselectedProviderNames.join(','))

            }

            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues((prev)=>({
                ...prev,
            }));
            dispatch(resetTempFilterOpen())
            dispatch(resetTempFilterUsersOpen())
            dispatch(resetTempFilterOrgOpen())
            dispatch(resetTempFilterProviderOpen())
            // Remove filter-related keys from searchParams
            
            
            params?.selected_user_ids&&delete params.selected_user_ids
            params?.unselected_user_ids&&delete params.unselected_user_ids
            params?.selected_patient_ids&&delete params.selected_patient_ids
            params?.unselected_patient_ids&&delete params.unselected_patient_ids
            params?.selected_organization_ids&&delete params.selected_organization_ids
            params?.unselected_organization_ids&&delete params.unselected_organization_ids
            params?.selected_provider_ids&&delete params.selected_provider_ids
            params?.unselected_provider_ids&&delete params.unselected_provider_ids
   
            setSearchParams({ ...params });
        }
    };

    const handlePlaceHolder =(Username) => {
        let displayNumber=''

        
        if(Username==="patient"){
            if(suggestions.trim()===''){
                if((!isSelectAllChecked&&selectedPatients[0]==='empty')||(totalPatients===0)){
                    return `Select patient name`
                }
                if(isCheckedPatients&&(unselectedPatients?.length==0&&selectedPatients?.length===0)){
                    displayNumber = totalPatients
                    return `${displayNumber} Selected`
                }else if(!isCheckedPatients&&suggestions.trim()===''&&(selectedPatients.length===0&&unselectedPatients.length===0)){
                    return `Select patient name`
                }else if(isSelectAllChecked&&(unselectedPatients?.length>0||selectedPatients?.length>0)){
                    return `${totalPatients-unselectedPatients.length} Selected`
                }else if(!isSelectAllChecked&&(unselectedPatients?.length>0||selectedPatients?.length>0)){
                    return `${selectedPatients?.length} Selected`
                }
            }else{
                if(!isSelectAllChecked&&selectedPatients[0]==='empty'){
                    return `Select patient name`
                }

                if(isSelectAllChecked){
                    return `${totalPatients-unselectedPatients.length} Selected`
                }
                else if(!isSelectAllChecked){
                    return `${selectedPatients?.length} Selected`
                }
            }
            
        }
        else if(Username==="provider") {
            if(providersuggestions.trim()===''){
                if(!isSelectAllProviderChecked&&selectedProviderNames[0]==='empty'||(totalProvider===0)){
                    return `Select provider name`
                }
                if(isCheckedProvider&&(unselectedProviderNames?.length==0&&selectedProviderNames?.length===0)){
                    return `${totalProvider} Selected`
                }else if(!isCheckedProvider&&providersuggestions.trim()===''&&(selectedProviderNames.length===0&&unselectedProviderNames.length===0)){
                    return `Select provider name`
                }else if(isSelectAllProviderChecked&&(unselectedProviderNames?.length>0||selectedProviderNames?.length>0)){
                    return `${totalProvider-unselectedProviderNames.length} Selected`
                }else if(!isSelectAllProviderChecked&&(unselectedProviderNames?.length>0||selectedProviderNames?.length>0)){
                    return `${selectedProviderNames?.length} Selected`
                }
            }else{
                if(!isSelectAllProviderChecked&&selectedProviderNames[0]==='empty'){
                    return `Select provider name`
                }
                if(isSelectAllProviderChecked){
                    return `${totalProvider-unselectedProviderNames.length} Selected`
                }else if(!isSelectAllProviderChecked){
                    return `${selectedProviderNames?.length} Selected`
                }
               
            }
        }
        else if(Username==="username") {
            if(usersuggestions.trim()===''){
                if(!isSelectAllUsersChecked&&selectedUserNames[0]==='empty'||(totalUsers===0)){
                    return `Select user name`
                }
                if(isCheckedUsers&&(unselectedUserNames?.length==0&&selectedUserNames?.length===0)){
                    return `${totalUsers} Selected`
                }else if(!isCheckedUsers&&usersuggestions.trim()===''&&(selectedUserNames.length===0&&unselectedUserNames.length===0)){
                    return `Select user name`
                }else if(isSelectAllUsersChecked&&(unselectedUserNames?.length>0||selectedUserNames?.length>0)){
                    return `${totalUsers-unselectedUserNames.length} Selected`
                }else if(!isSelectAllUsersChecked&&(unselectedUserNames?.length>0||selectedUserNames?.length>0)){
                    return `${selectedUserNames?.length} Selected`
                }
            }else{
                if(!isSelectAllUsersChecked&&selectedUserNames[0]==='empty'){
                    return `Select user name`
                }
                if(isSelectAllUsersChecked){
                    return `${totalUsers-unselectedUserNames.length} Selected`
                }else if(!isSelectAllUsersChecked){
                    return `${selectedUserNames?.length} Selected`
                }
               
            }
        }       
        else {
            if(orgsuggestions.trim()===''){
                if(!isSelectAllOrgChecked&&selectedOrgNames[0]==='empty'||totalOrganization===0){
                    return `Select organization name`
                }
                if(isCheckedOrg&&(unselectedOrgNames?.length==0&&selectedOrgNames?.length===0)){
                    return `${totalOrganization} Selected`
                }else if(!isCheckedOrg&&orgsuggestions.trim()===''&&(selectedOrgNames?.length===0&&unselectedOrgNames?.length===0)){
                    return `Select organization name`
                }else if(isSelectAllOrgChecked&&(unselectedOrgNames?.length>0||selectedOrgNames?.length>0)){
                    return `${totalOrganization-unselectedOrgNames.length} Selected`
                }else if(!isSelectAllOrgChecked&&(unselectedOrgNames?.length>0||selectedOrgNames?.length>0)){
                    return `${selectedOrgNames?.length} Selected`
                }
            }else{
                if(!isSelectAllOrgChecked&&selectedOrgNames[0]==='empty'){
                    return `Select organization name`
                }
                if(isSelectAllOrgChecked){
                    return `${totalOrganization-unselectedOrgNames?.length} Selected`
                }else if(!isSelectAllOrgChecked){
                    return `${selectedOrgNames?.length} Selected`
                }
               
            }
        }
        
       

    }

    useEffect(()=>{
        !isFilterOpen?dispatch(resetTempFilterOpen()):''
        !isFilterOpen?dispatch(resetTempFilterUsersOpen()):''
        !isFilterOpen?dispatch(resetTempFilterOrgOpen()):''
        !isFilterOpen?dispatch(resetTempFilterProviderOpen()):''
        if(isFilterOpen){
            if(searchParams.get('selected_patient_ids')===null&&searchParams.get('unselected_patient_ids')===null){
                setIsSelectAllChecked(true)
            }
            if(searchParams.get('selected_patient_ids')==='empty'){
                setIsSelectAllChecked(false)
            }
            if(searchParams.get('selected_user_ids')===null&&searchParams.get('unselected_user_ids')===null){
                setisSelectAllUsersChecked(true)
            }
            if(searchParams.get('selected_user_ids')==='empty'){
                setisSelectAllUsersChecked(false)
            }
            if(searchParams.get('selected_organization_ids')===null&&searchParams.get('unselected_organization_ids')===null){
                setisSelectAllOrgChecked(true)
            }
            if(searchParams.get('selected_organization_ids')==='empty'){
                setisSelectAllOrgChecked(false)
            }
            if(searchParams.get('selected_provider_ids')===null&&searchParams.get('unselected_provider_ids')===null){
                setisSelectAllProviderChecked(true)
            }
            if(searchParams.get('selected_provider_ids')==='empty'){
                setisSelectAllProviderChecked(false)
            }

            if(searchParams.get('selected_patent_ids')==='empty' || searchParams.get('selected_user_ids')==='empty' || searchParams.get('selected_organization_ids')==='empty' || searchParams.get('selected_provider_ids')==='empty'){
                searchParams.get('selected_patent_ids')==='empty'?dispatch(handleEmptyDropdown()):''
                searchParams.get('selected_user_ids')==='empty'?dispatch(handleEmptyUsersDropdown()):''
                searchParams.get('selected_provider_ids')==='empty'?dispatch(handleEmptyProviderDropdown()):''
                searchParams.get('selected_organization_ids')==='empty'?dispatch(handleEmptyOrgDropdown()):''
            }

            if(searchParams.get('selected_patient_ids')&&!(searchParams.get('selected_patent_ids')==='empty')){
                dispatch(handleFillFromSearchParamsPatients([decodeURIComponent(searchParams.get('selected_patient_ids')).split(',')?.filter(item=>item!=='empty'),[]]))
            }else if(searchParams.get('unselected_patient_ids')){
                dispatch(handleFillFromSearchParamsPatients([[],decodeURIComponent(searchParams.get('unselected_patient_ids')).split(',')?.filter(item=>item!=='empty')]))
            }

            if(searchParams.get('selected_user_ids')&&!(searchParams.get('selected_user_ids')==='empty')){
                dispatch(handleFillFromSearchParamsUsers([decodeURIComponent(searchParams.get('selected_user_ids')).split(',')?.filter(item=>item!=='empty'),[]]))
            }else if(searchParams.get('unselected_user_ids')){
                dispatch(handleFillFromSearchParamsUsers([[],decodeURIComponent(searchParams.get('unselected_user_ids')).split(',')?.filter(item=>item!=='empty')]))
            }

            if(searchParams.get('selected_organization_ids')&&!(searchParams.get('selected_organization_ids')==='empty')){
                dispatch(handleFillFromSearchParamsOrg([decodeURIComponent(searchParams.get('selected_organization_ids')).split(',')?.filter(item=>item!=='empty'),[]]))
            }else if(searchParams.get('unselected_organization_ids')){
                dispatch(handleFillFromSearchParamsOrg([[],decodeURIComponent(searchParams.get('unselected_organization_ids')).split(',')?.filter(item=>item!=='empty')]))
            }

            if(searchParams.get('selected_provider_ids')&&!(searchParams.get('selected_provider_ids')==='empty')){
                dispatch(handleFillFromSearchParamsProviders([decodeURIComponent(searchParams.get('selected_provider_ids')).split(',')?.filter(item=>item!=='empty')?.map(item=>item==="''"?'blankREC':item),[]]))
            }else if(searchParams.get('unselected_provider_ids')){
                dispatch(handleFillFromSearchParamsProviders([[],decodeURIComponent(searchParams.get('unselected_provider_ids')).split(',')?.filter(item=>item!=='empty')?.map(item=>item==="''"?'blankREC':item)]))
            }
        }
    },[isFilterOpen])

    return (
        <div className='xl:relative ml-2.5'>
            <button id='filter' data-testid={'filter-btn'} type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
               
                    <div  className=' absolute top-14 filter_top right-0  left-auto bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[494px] z-[99]'>
                        <div className='flex justify-between items-center mb-4'>
                            <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                            <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setdateError(false)}}>
                                <img src="/images/cross_mark_gray.svg" alt="icon" />
                            </button>
                        </div>
                        <div className='flex flex-wrap -mx-2'>
                            <div className={`w-1/2 px-2 mb-4`}>
                                <div className="w-full">
                                    <PatientDropdownAlertWithSearch
                                        label={"Patient Name"}
                                        id={`patient_name`}
                                        placeholder={handlePlaceHolder('patient')}
                                        disabled={false}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        filterValues={filterValues}
                                        index={0}
                                        value={''}
                                        isSelectAllChecked={isSelectAllChecked}
                                        setIsSelectAllChecked={setIsSelectAllChecked}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                        suggestions={suggestions}
                                        setSuggestions={setSuggestions}
                                        isSearchedSelectAllChecked={isSearchedSelectAllChecked}
                                        setIsSearchedSelectAllChecked={setIsSearchedSelectAllChecked}
                                    />
                                </div>
                            </div>
                            <div className={`w-1/2 px-2 mb-4`}>
                                <div className="w-full">
                                    <DropdownWithSearchProvider
                                        label={"Provider Name"}
                                        id={`provider_name`}
                                        placeholder={handlePlaceHolder('provider')}
                                        disabled={false}
                                        filterValues={filterValues}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        index={0}
                                        value={''}
                                        
                                        isSelectAllProviderChecked={isSelectAllProviderChecked}
                                        setisSelectAllProviderChecked={setisSelectAllProviderChecked}
                                        isSearchedSelectAllProviderChecked={isSearchedSelectAllProviderChecked}
                                        setisSearchedSelectAllProviderChecked={setisSearchedSelectAllProviderChecked}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                        providersuggestions={providersuggestions}
                                        setprovidersuggestions={setprovidersuggestions}
                                    />
                                </div>
                            </div>
                            <div className={`w-1/2 px-2 mb-4`}>
                                <div className="w-full">
                                    <DropdownWithSearchUser
                                        label={"User Name"}
                                        id={`user_name`}
                                        placeholder={handlePlaceHolder('username')}
                                        disabled={false}
                                        filterValues={filterValues}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        index={0}
                                        value={''}
                                        isSelectAllUsersChecked={isSelectAllUsersChecked}
                                        setisSelectAllUsersChecked={setisSelectAllUsersChecked}
                                        isSearchedSelectAllUsersChecked={isSearchedSelectAllUsersChecked}
                                        setisSearchedSelectAllUsersChecked={setisSearchedSelectAllUsersChecked}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                        usersuggestions={usersuggestions}
                                        setusersuggestions={setusersuggestions}
                                    />
                                </div>
                            </div>
                            <div className={`w-1/2 px-2 mb-4`}>
                                <div className="w-full">
                                    <DropdownWithSearchOrganization
                                        label={"Organization Name"}
                                        id={`organization_name`}
                                        placeholder={handlePlaceHolder('organization')}
                                        disabled={false}
                                        filterValues={filterValues}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        index={0}
                                        value={''}
                                        
                                        isSelectAllOrgChecked={isSelectAllOrgChecked}
                                        setisSelectAllOrgChecked={setisSelectAllOrgChecked}
                                        isSearchedSelectAllOrgChecked={isSearchedSelectAllOrgChecked}
                                        setisSearchedSelectAllOrgChecked={setisSearchedSelectAllOrgChecked}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                        orgsuggestions={orgsuggestions}
                                        setorgsuggestions={setorgsuggestions}
                                    />
                                </div>
                            </div>
                            
                        </div>
                        <div className="flex mt-[13px] justify-between">
                            <button  onClick={()=>{handleApplyFilter(false),setIsFilterOpen(false)}}
                                id="clear-button"
                                data-testid={'clear-btn'}
                                className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                            >Clear All</button>
                            <button  
                                onClick={()=>{
                                    
                                    handleApplyFilter(true),setIsFilterOpen(false)}}
                                type='button'
                                id="apply-filter"
                                data-testid="apply-btn"
                                disabled={
                                    (selectedPatients?.length===0&&unselectedPatients?.length===0&&!isSelectAllChecked)
                                    &&(selectedProviderNames?.length===0&&unselectedProviderNames?.length===0&&!isSelectAllProviderChecked)
                                    &&(selectedOrgNames?.length===0&&unselectedOrgNames?.length===0&&!isSelectAllOrgChecked)
                                    &&(selectedUserNames?.length===0&&unselectedUserNames?.length===0&&!isSelectAllUsersChecked)
                                } 
                                className={`py-2.5 w-[106px] px-4 rounded-[16px]  ${(selectedPatients?.length===0&&unselectedPatients?.length===0&&!isSelectAllChecked)&&(selectedProviderNames?.length===0&&unselectedProviderNames?.length===0&&!isSelectAllProviderChecked)&&(selectedOrgNames?.length===0&&unselectedOrgNames?.length===0&&!isSelectAllOrgChecked)&&(selectedUserNames?.length===0&&unselectedUserNames?.length===0)?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}   text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                Apply
                            </button>
                        </div>
                    </div>
                // </motion.div>
            }
        </div>  
    )
}
